export interface TractEventParams {
  name: string
  value: number
  isInSandbox: boolean
}

export function trackTransactionConfirmation({ name, value, isInSandbox }: TractEventParams): void {
  trackEvent(
    {
      category: 'Transaction',
      action: 'Confirmation',
      name,
      value,
    },
    isInSandbox,
  )
}

export function trackAction({ name, isInSandbox }: Omit<TractEventParams, 'value'>): void {
  trackEvent(
    {
      category: 'Call to action',
      action: 'Button click',
      name,
    },
    isInSandbox,
  )
}

interface Event {
  category: string
  action: string
  name: string
  value?: number
}

function trackEvent(event: Event, isInSandbox: boolean): void {
  if (isInSandbox) {
    return
  }
  if (!('cookie3' in window)) {
    return
  }
  ;(window.cookie3 as any).trackEvent(event)
}
